import { Outlet } from '@tanstack/react-router';
import React from 'react';
import StickyBox from 'react-sticky-box';

import ColumnLoading from '@/components/column-loading';
import Layout, { useWindowControlsOverlay } from '@/components/ui/layout';

const SettingsPage = React.lazy(() => import('@/pages/settings/settings'));

const SettingsSections: React.FC = () => {
  const wcoRect = useWindowControlsOverlay();
  const offsetTop = wcoRect && wcoRect.x > 0 ? 16 + wcoRect.y : 16;

  return (
    <div className='layout__settings-sections'>
      <StickyBox offsetTop={offsetTop} className={undefined} style={undefined}>
        <React.Suspense fallback={<ColumnLoading />}>
          <SettingsPage />
        </React.Suspense>
      </StickyBox>
    </div>
  );
};

const SettingsLayout: React.FC = () => (
  <>
    <SettingsSections />

    <Layout.Main>
      <Outlet />
    </Layout.Main>
  </>
);

export { SettingsLayout as default };
